module.exports = __webpack_public_path__ + "static/media/1-3.3c0c47c3.svg";